import { StyledCol, StyledTitle } from '@/shared/styles';
import { StyledAllIssues } from '../AccessibilityIssues.styles';
import { RadioGroup } from '@/shared/components/Radio/Radio';
import { AccessibilityCategory } from './AccessibilityCategory';
import {
  IssuesCategoryType,
  SeverityLevel,
} from '@/stores/AccessibilityCheckerStore/AccessibilityChecker.consts';
import { useAccessibilityCheckerStore } from '@/stores/AccessibilityCheckerStore/AccessibilityCheckerStore';
import { useTranslation } from 'react-i18next';

export const AllIssues: React.FC = () => {
  const { t } = useTranslation();
  const { selectSeverity, getSelectedSeverityIndex } = useAccessibilityCheckerStore();
  const severityLevelValues = Object.values(SeverityLevel).map((value) =>
    t(`free_tools.accessibility_checker.severity.${value}`)
  );
  return (
    <StyledAllIssues>
      <StyledCol $gap={16}>
        <StyledTitle level={3} $size={24}>
          {t('free_tools.accessibility_checker.all_issues')}:
        </StyledTitle>
        <RadioGroup
          value={getSelectedSeverityIndex()}
          setValue={selectSeverity}
          radioValues={[...severityLevelValues]}
          radioDirection="horizontal"
        />
      </StyledCol>
      <StyledCol $align="start" $gap={16}>
        {Object.values(IssuesCategoryType).map((issue, i) => (
          <AccessibilityCategory key={`issue${i}`} categoryType={issue} />
        ))}
      </StyledCol>
    </StyledAllIssues>
  );
};
